function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { useEffect, useMemo } from 'react';
import { getElementPosition, useElementPosition, useUpdate } from '@bydesign-ui/hooks';
import { useGetPopper } from './useGetPopper';
import { useTriggerGroup } from './useTriggerGroup';
export function useTrigger(getTrigger, options, triggerRef, triggerType, triggerId) {
  var popper = useGetPopper();
  var triggerGroup = useTriggerGroup();
  var update = useUpdate();

  var _options$captureOptio = options.captureOptions,
      captureOptions = _options$captureOptio === void 0 ? {} : _options$captureOptio,
      _options$disabled = options.disabled,
      disabled = _options$disabled === void 0 ? false : _options$disabled,
      disableToggleClose = options.disableToggleClose,
      data = options.data,
      extra = _objectWithoutProperties(options, ["captureOptions", "disabled", "disableToggleClose", "data"]);

  var trigger = useMemo(function () {
    return getTrigger(popper, triggerType, triggerId, triggerGroup);
  }, []);
  trigger.updateTriggerOptions({
    disabled: disabled,
    disableToggleClose: disableToggleClose,
    data: data
  });
  useElementPosition(triggerRef, function () {
    return trigger.isFocus() || trigger.isActiveShow();
  }, function (rect) {
    return trigger.updateRect(rect);
  }, captureOptions);
  useEffect(function () {
    trigger.updateReference(triggerRef.current);
  });
  useEffect(function () {
    var callback = function callback(activeShow) {
      if (!activeShow) return;

      if (triggerRef.current) {
        trigger.updateRect(getElementPosition(triggerRef.current));
      }

      update();
    };

    trigger.addListener('update-active', callback);
    return function () {
      trigger.removeListener('update-active', callback);
      trigger.dispose();
    };
  }, []);
  var result = {
    activeShow: trigger.isActiveShow()
  };
  return [trigger, result, extra];
}